/* This renders a button that redirects to the given 
   article when clicked

   Hassaan Ali Wattoo 
*/ 

import React from 'react';
import {
    Link
} from "react-router-dom";

class ReadArticleButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: this.props.url,
            theme: this.props.theme, 
        }
    }

    render() {
        return (
            <div className={`read-article-button ${this.props.theme}`}>
                <Link to={`${this.state.url}`}> {this.props.text ? this.props.text :"Read Article" } </Link>
                {/* <button onClick={() => window.location = this.props.url}>
                    Read Article >
                </button> */}
            </div>
        );
    }
        
    
}

export default ReadArticleButton;